import { tKey } from 'ember-intl';

export const SMART_INSIGHTS_TABS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
} as const;
export type SmartInsightsTab =
  (typeof SMART_INSIGHTS_TABS)[keyof typeof SMART_INSIGHTS_TABS];

export const isSmartInsightsTab = (value: string): value is SmartInsightsTab =>
  Object.values(SMART_INSIGHTS_TABS).includes(value as SmartInsightsTab);

export const SMART_INSIGHTS_ARCHIVE_REASONS = {
  ACTION_TAKEN: 'action_taken',
  ACTIONED_RECOMMENDATIONS: 'actioned_recommendations',
  ACTIONED_OTHER: 'actioned_other',
  NOT_ACTIONABLE: 'not_actionable',
} as const;
export type SmartInsightsArchiveReason =
  (typeof SMART_INSIGHTS_ARCHIVE_REASONS)[keyof typeof SMART_INSIGHTS_ARCHIVE_REASONS];

export const SMART_INSIGHTS_ARCHIVE_REASON_TRANSLATIONS: Record<
  SmartInsightsArchiveReason,
  string
> = {
  [SMART_INSIGHTS_ARCHIVE_REASONS.ACTION_TAKEN]: tKey(
    'smart_insights.archive.action_taken',
  ),
  [SMART_INSIGHTS_ARCHIVE_REASONS.ACTIONED_RECOMMENDATIONS]: tKey(
    'smart_insights.archive.actioned_recommendation_count',
  ),
  [SMART_INSIGHTS_ARCHIVE_REASONS.ACTIONED_OTHER]: tKey(
    'smart_insights.archive.actioned_other',
  ),
  [SMART_INSIGHTS_ARCHIVE_REASONS.NOT_ACTIONABLE]: tKey(
    'smart_insights.archive.not_actionable',
  ),
};

export const SMART_INSIGHTS_VIEWS = {
  CALENDAR: 'calendar',
  LIST: 'list',
} as const;
export type SmartInsightsView =
  (typeof SMART_INSIGHTS_VIEWS)[keyof typeof SMART_INSIGHTS_VIEWS];

export const isSmartInsightsView = (
  value: string,
): value is SmartInsightsView => {
  return Object.values(SMART_INSIGHTS_VIEWS).includes(
    value as SmartInsightsView,
  );
};

export const SMART_INSIGHTS_KPI_COMPARISON_PERIODS = {
  YESTERDAY: 'yesterday',
  THREE_DAYS_AGO: '3_days_ago',
  SEVEN_DAYS_AGO: '7_days_ago',
} as const;
export type SmartInsightsKpiComparisonPeriod =
  (typeof SMART_INSIGHTS_KPI_COMPARISON_PERIODS)[keyof typeof SMART_INSIGHTS_KPI_COMPARISON_PERIODS];

export const SMART_INSIGHTS_KPI_COMPARISON_PERIOD_TRANSLATIONS: Record<
  SmartInsightsKpiComparisonPeriod,
  ReturnType<typeof tKey>
> = {
  [SMART_INSIGHTS_KPI_COMPARISON_PERIODS.YESTERDAY]: tKey(
    'smart_insights.detail_view.vs_yesterday',
  ),
  [SMART_INSIGHTS_KPI_COMPARISON_PERIODS.THREE_DAYS_AGO]: tKey(
    'smart_insights.detail_view.vs_3_days_ago',
  ),
  [SMART_INSIGHTS_KPI_COMPARISON_PERIODS.SEVEN_DAYS_AGO]: tKey(
    'smart_insights.detail_view.vs_7_days_ago',
  ),
};

export const SMART_INSIGHTS_FEEDBACK_TYPES = {
  NEGATIVE: 'negative',
  POSITIVE: 'positive',
  SUPER_POSITIVE: 'super-positive',
} as const;
export type SmartInsightsFeedbackType =
  (typeof SMART_INSIGHTS_FEEDBACK_TYPES)[keyof typeof SMART_INSIGHTS_FEEDBACK_TYPES];

export const SMART_INSIGHTS_FEEDBACK_TYPE_TO_USERSNAP_EVENT: Record<
  SmartInsightsFeedbackType,
  string
> = {
  [SMART_INSIGHTS_FEEDBACK_TYPES.NEGATIVE]: 'smart-insights-feedback-negative',
  [SMART_INSIGHTS_FEEDBACK_TYPES.POSITIVE]: 'smart-insights-feedback-positive',
  [SMART_INSIGHTS_FEEDBACK_TYPES.SUPER_POSITIVE]:
    'smart-insights-feedback-super-positive',
};

// Usersnap truncates its API event names at 38 characters, hence `reco`
export const SMART_INSIGHTS_RECOMMENDATIONS_FEEDBACK_TYPE_TO_USERSNAP_EVENT: Record<
  SmartInsightsFeedbackType,
  string
> = {
  [SMART_INSIGHTS_FEEDBACK_TYPES.NEGATIVE]: 'smart-insights-reco-negative',
  [SMART_INSIGHTS_FEEDBACK_TYPES.POSITIVE]: 'smart-insights-reco-positive',
  [SMART_INSIGHTS_FEEDBACK_TYPES.SUPER_POSITIVE]:
    'smart-insights-reco-super-positive',
};

export const SMART_INSIGHTS_VIEW_LOCAL_STORAGE_KEY = 'smartInsightsView';

// Intercom product tour: https://app.intercom.com/a/apps/gyngqx5w/outbound/tour/57546189
export const SMART_INSIGHTS_TOUR_ID = '57546189';

export const SMART_INSIGHTS_HELP_ARTICLE =
  'en/articles/13561813-smart-insights-overview';
